// Configuration for the Wordle Solver API
export const API_CONFIG = {
  // This will be overridden by useApiConfig hook which loads from config.json
  BASE_URL: process.env.REACT_APP_API_URL || '',
};

export const WORDLE_CONFIG = {
  WORD_LENGTH: 5,
  MAX_GUESSES: 6,
};
